import { GridConditionsWidget } from './gridConditions';
import { FuelMixWidget } from './fuelmix';
import {CsatSupplyDemandWidget } from './csatSupplyDemand';

const Widgets = {
	GridConditionsWidget: GridConditionsWidget,
	FuelMixWidget: FuelMixWidget,
	CsatSupplyDemandWidget: CsatSupplyDemandWidget
}
global.Widgets = Widgets;